import * as React from 'react';

import { createReactRenderer } from 'helpers/react-renderer';
import { Config, ConfigProvider } from 'root/apps/contexts/ConfigContext';
import ErrorMessageProvider from 'root/apps/InventoryCountReconcile/contexts/AlertMessage';
import ReconcileDataProvider from 'root/apps/InventoryCountReconcile/contexts/ReconcileData';
import InventoryCountReconcileView from 'root/apps/InventoryCountReconcile/views/index';

interface InventoryCountReconcileProps {
  config?: Config;
}

const InventoryCountReconcile: React.FC<InventoryCountReconcileProps> = ({ config }) => {
  return (
    <ConfigProvider config={config}>
      <ErrorMessageProvider>
        <ReconcileDataProvider>
          <InventoryCountReconcileView />
        </ReconcileDataProvider>
      </ErrorMessageProvider>
    </ConfigProvider>
  );
};

const RenderedComponent = createReactRenderer({
  component: InventoryCountReconcile,
  selector: '[data-react-root="InventoryCountReconcile"]',
});

export default InventoryCountReconcile;

history.onChangeState(
  [
    {
      name: ['inventory_count.views.inventory_count'],
      form_name: 'view',
      tab: 'reconcile',
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
